import React, {useEffect} from "react"
import theme from "./../../../Theme/Theme"
import { Div, Text, Row, Col, Icon } from "atomize";
import styled from "styled-components";
import {apiGet} from "../../../Api";
import {baseUrl} from "../../../Constants/constants";
import Skeleton from "react-loading-skeleton";

function Index(props) {
  const image = props.image;
  const [data, setData] = React.useState({});


  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`file/file/${image.id}?jsonapi_include=1`);
      setData(result.data.data);
    }
    fetchData();
  }, [props.image]);

  return (
    <>
      { data.uri &&
      <img alt={image.meta.alt ? image.meta.alt : data.filename } src={ baseUrl + data.uri.url} />
      }
      {
        !data.uri &&
        <Skeleton height={'4rem'}/>
      }
    </>
  )
}

export default Index;
